import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { jamestownConfig } from "./data";

export default function JamestownPage() {
  return <CityPageTemplate config={jamestownConfig} />;
}